import { Button, Typography } from "@mui/material";
import { Box, SxProps } from "@mui/system";
import { createHref } from "../app/services/routing";
import ContactText from "../components/ContactText";

const boxSx: SxProps = {
    display: "flex",
    flexDirection: "column",
    flex: 1,
};

const buttonSx: SxProps = {
    textTransform: "none",
    backgroundColor: "success.contrastText",
    color: "primary.contrastText",
    paddingY: "12px",

    "&:hover": {
        color: "primary.contrastText",
    },
};

const buttonBoxSx: SxProps = {
    display: "flex",
    justifyContent: "flex-end",
    flexDirection: "column",
    flex: 1,
};

export default function PageNotFoundError() {
    return (
        <>
            <Box sx={boxSx}>
                <Typography variant="h2" gutterBottom color="error.main">
                    Page not found?
                </Typography>

                <Typography variant="h5" gutterBottom>
                    The page you’re looking for does not exist.
                </Typography>

                <Typography gutterBottom>
                    It looks like you found your way to a page that doesn&apos;t really exist. Please let us know how
                    you got here, so that we can fix whatever sent you here!
                </Typography>

                <Typography gutterBottom>
                    <ContactText />
                </Typography>

                <Box sx={buttonBoxSx}>
                    <Button
                        id="redirect"
                        variant="contained"
                        color="success"
                        fullWidth
                        sx={buttonSx}
                        href={createHref("start")}
                    >
                        <Typography variant="h5">Go to Sign In...</Typography>
                    </Button>
                </Box>
            </Box>
        </>
    );
}
